import { Component, ReactNode } from 'react';

/**
 * Keeps one broken page from taking the whole atlas down: the navigation stays, the page says
 * what happened in plain words, and moving to another page resets it.
 */
export class PageBoundary extends Component<{ children: ReactNode; resetKey: string }, { error: Error | null; key: string }> {
  state = { error: null as Error | null, key: this.props.resetKey };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  static getDerivedStateFromProps(props: { resetKey: string }, state: { error: Error | null; key: string }) {
    return props.resetKey !== state.key ? { error: null, key: props.resetKey } : null;
  }

  componentDidCatch(error: Error) {
    console.error('Page failed to render:', error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="page-head" role="alert">
        <span className="label">Something went wrong</span>
        <h1>This page could not be drawn</h1>
        <p>
          The rest of the atlas still works. <a href="#">Go to the start</a> or pick another page above.
        </p>
        <p className="muted" style={{ fontSize: '0.84rem' }}>
          {this.state.error.message}
        </p>
      </div>
    );
  }
}
